<template>
  <div class="client-login-page">
    <div class="client-login-title">
      <div v-if="emblem" class="text-center">
        <el-image class="client-login-title-img" :src="emblem" fit="cover"></el-image>
      </div>
      <div class="text-center font-size-30 font-weight-bolder">
        {{ storeName }}
      </div>
    </div>
    <div class="client-login flex">
      <div class="flex flex-center flex1">
        <img class="width-full" src="@/assets/img/login-img.png" alt="" />
      </div>
      <!--  登录  -->
      <div v-if="isLoginShow" class="client-login-right" v-loading="loading">
        <h1>登录</h1>
        <div>您好！{{ storeName }}欢迎您，请登录~</div>
        <div class="m-t-10">
          <el-tabs v-model="activeName">
            <el-tab-pane label="账号密码登录" name="one">
              <div class="m-b-10">
                <el-input
                  v-model="loginData.phone"
                  clearable
                  placeholder="请输入用户名/手机号"
                  @keyup.enter.native="login"
                ></el-input>
              </div>
              <div v-if="accountList.length > 1" class="m-b-10">
                <el-select class="width-full" v-model="loginData.account" clearable placeholder="请选择账号">
                  <el-option v-for="item in accountList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </div>
              <div class="m-b-10">
                <PassWord
                  v-model="loginData.password"
                  :password="loginData.password"
                  :is-message="false"
                  placeholder="请输入登录密码（6-16位数字或字母）"
                  @keyup.enter.native="login"
                />
              </div>
              <div class="m-b-10 flex flex-center font-size-14">
                <div @click="forgetPassword" class="cursor-pointer">忘记密码？</div>
                <div class="flex1"></div>
                <div v-if="showRegister" @click="toRegister" class="cursor-pointer">还没有账号，去注册</div>
              </div>
              <div class="m-b-20 flex font-size-14 text-999">
                <span>登录即代表您已同意</span>
                <span @click="serviceAgreement" class="font-warning cursor-pointer">《用户服务协议》</span>
                <span>和</span>
                <span @click="privacyPolicy" class="font-warning cursor-pointer">《隐私政策》</span>
              </div>
              <el-button @click="login" class="width-full" type="primary">立即登录</el-button>
              <StoreCom />
            </el-tab-pane>
            <el-tab-pane label="手机验证登录" name="two">
              <div class="m-b-10">
                <el-input
                  v-model="loginData.phone"
                  maxlength="11"
                  clearable
                  placeholder="请输入手机号"
                  @keyup.enter.native="login"
                ></el-input>
              </div>
              <div v-if="accountList.length > 1" class="m-b-10">
                <el-select class="width-full" v-model="loginData.account" clearable placeholder="请选择账号">
                  <el-option v-for="item in accountList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </div>
              <div class="m-b-10">
                <SMSCode
                  v-model="loginData.smsCaptcha"
                  :smsCaptcha="loginData.smsCaptcha"
                  :phone="loginData.phone"
                  type="login"
                />
              </div>
              <div v-if="showRegister" class="m-b-10 flex flex-center font-size-14">
                <div class="flex1"></div>
                <div @click="toRegister" class="cursor-pointer">还没有账号，去注册</div>
              </div>
              <div class="m-b-20 flex font-size-14 text-999">
                <span>登录即代表您已同意</span>
                <span @click="serviceAgreement" class="font-warning cursor-pointer">《用户服务协议》</span>
                <span>和</span>
                <span @click="privacyPolicy" class="font-warning cursor-pointer">《隐私政策》</span>
              </div>
              <el-button @click="login" class="width-full" type="primary">立即登录</el-button>
              <StoreCom />
            </el-tab-pane>
          </el-tabs>
          <div v-if="false">
            <el-divider></el-divider>
            <div class="m-b-10 text-center">
              使用三方账号登录
            </div>
            <div class="text-center">
              <svg
                @click="weiXinLogin"
                t="1671502179807"
                class="cursor-pointer"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2739"
                data-spm-anchor-id="a313x.7781069.0.i1"
                width="40"
                height="40"
              >
                <path
                  d="M337.387283 341.82659c-17.757225 0-35.514451 11.83815-35.514451 29.595375s17.757225 29.595376 35.514451 29.595376 29.595376-11.83815 29.595376-29.595376c0-18.49711-11.83815-29.595376-29.595376-29.595375zM577.849711 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763zM501.641618 401.017341c17.757225 0 29.595376-12.578035 29.595376-29.595376 0-17.757225-11.83815-29.595376-29.595376-29.595375s-35.514451 11.83815-35.51445 29.595375 17.757225 29.595376 35.51445 29.595376zM706.589595 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763z"
                  fill="#28C445"
                  p-id="2740"
                ></path>
                <path
                  d="M510.520231 2.959538C228.624277 2.959538 0 231.583815 0 513.479769s228.624277 510.520231 510.520231 510.520231 510.520231-228.624277 510.520231-510.520231-228.624277-510.520231-510.520231-510.520231zM413.595376 644.439306c-29.595376 0-53.271676-5.919075-81.387284-12.578034l-81.387283 41.433526 22.936416-71.768786c-58.450867-41.433526-93.965318-95.445087-93.965317-159.815029 0-113.202312 105.803468-201.988439 233.803468-201.98844 114.682081 0 216.046243 71.028902 236.023121 166.473989-7.398844-0.739884-14.797688-1.479769-22.196532-1.479769-110.982659 1.479769-198.289017 85.086705-198.289017 188.67052 0 17.017341 2.959538 33.294798 7.398844 49.572255-7.398844 0.739884-15.537572 1.479769-22.936416 1.479768z m346.265896 82.867052l17.757225 59.190752-63.630058-35.514451c-22.936416 5.919075-46.612717 11.83815-70.289017 11.83815-111.722543 0-199.768786-76.947977-199.768786-172.393063-0.739884-94.705202 87.306358-171.653179 198.289017-171.65318 105.803468 0 199.028902 77.687861 199.028902 172.393064 0 53.271676-34.774566 100.624277-81.387283 136.138728z"
                  fill="#28C445"
                  p-id="2741"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <!--  微信登录  -->
      <div v-if="isWeiXinLogin" class="client-login-right flex-center" v-loading="loading">
        <iframe id="iframeWeChat" :src="iframeUrl"></iframe>
        <div class="flex flex-center font-size-14 font-primary">
          <div @click="changeWeiXinLogin" class="cursor-pointer">已有账号，去登录</div>
        </div>
        <StoreCom />
      </div>
      <!--  注册  -->
      <div v-if="isRegister" class="client-login-right" v-loading="loading">
        <h1>注册</h1>
        <div>您好！思锐客户订货系统欢迎您，请先注册账号~</div>
        <div class="font-size-12 font-warning m-t-5">* 下列信息均为必填项，请耐心填写</div>
        <div class="m-t-10">
          <div class="m-b-10">
            <el-input
              v-model="registerData.name"
              maxlength="18"
              clearable
              placeholder="请输入姓名，如：xxx公司-张三"
            ></el-input>
          </div>
          <div class="m-b-10">
            <el-input
              v-model="registerData.phone"
              maxlength="11"
              clearable
              :readonly="readonly"
              placeholder="请输入手机号"
            ></el-input>
          </div>
          <div class="m-b-10">
            <SMSCode
              v-model="registerData.smsCaptcha"
              :smsCaptcha="registerData.smsCaptcha"
              :phone="registerData.phone"
              type="register"
            />
          </div>
          <div class="m-b-10">
            <PassWord v-model="registerData.password" :password="registerData.password" :readonly="readonly" />
          </div>
          <div class="m-b-10">
            <SelectArea
              class="width-full"
              :areaId="registerData.areaId"
              size="medium"
              placeholder="请选择所在地区"
              @change="areaChange"
            />
          </div>
          <div class="m-b-10 flex flex-center font-size-14">
            <div @click="toLogin" class="cursor-pointer">已有账号，去登录</div>
            <div class="flex1"></div>
          </div>
          <div class="m-b-20 flex font-size-14 text-999">
            <el-checkbox v-model="registerData.read"></el-checkbox>
            <span class="m-l-10">我已阅读并同意</span>
            <span @click="serviceAgreement" class="font-warning cursor-pointer">《用户服务协议》</span>
            <span>和</span>
            <span @click="privacyPolicy" class="font-warning cursor-pointer">《隐私政策》</span>
          </div>
          <el-button @click="register" class="width-full" type="primary">立即注册</el-button>
          <StoreCom />
        </div>
      </div>
      <!--  选择身份  -->
      <div v-if="isSelectIdentity && !isTransfinite" class="client-login-right">
        <div @click="createEnterprise" class="select-identity-item flex flex-center">
          <img class="w-30" src="@/assets/img/icons/icon-enterprise.png" alt="" />
          <div class="flex1 text-primary font-size-18 m-l-20">
            创建新企业
          </div>
          <svg
            t="1724048913638"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3530"
            width="32"
            height="32"
          >
            <path
              d="M514 114.3c-219.9 0-398.8 178.9-398.8 398.8 0 220 178.9 398.9 398.8 398.9s398.8-178.9 398.8-398.9c0-219.8-178.9-398.8-398.8-398.8z m232.1 440.4L582 718.8c-22.9 22.9-60.2 22.9-83.1 0-11.5-11.5-17.2-26.5-17.2-41.5s5.7-30.1 17.2-41.5l63.8-63.8H334c-32.5 0-58.8-26.3-58.8-58.8s26.3-58.8 58.8-58.8h228.7l-63.8-63.8c-22.9-22.9-22.9-60.2 0-83.1 22.9-22.9 60.2-22.9 83.1 0l164.1 164.1c22.9 23 22.9 60.2 0 83.1z"
              fill="#6589f8"
              p-id="3531"
            ></path>
          </svg>
        </div>
        <div v-if="false" @click="addEnterprise" class="select-identity-item flex flex-center m-t-20">
          <img class="w-30" src="@/assets/img/icons/icon-enterprises.png" alt="" />
          <div class="flex1 text-primary font-size-18 m-l-20">
            加入已有企业
          </div>
          <svg
            t="1724048913638"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3530"
            width="32"
            height="32"
          >
            <path
              d="M514 114.3c-219.9 0-398.8 178.9-398.8 398.8 0 220 178.9 398.9 398.8 398.9s398.8-178.9 398.8-398.9c0-219.8-178.9-398.8-398.8-398.8z m232.1 440.4L582 718.8c-22.9 22.9-60.2 22.9-83.1 0-11.5-11.5-17.2-26.5-17.2-41.5s5.7-30.1 17.2-41.5l63.8-63.8H334c-32.5 0-58.8-26.3-58.8-58.8s26.3-58.8 58.8-58.8h228.7l-63.8-63.8c-22.9-22.9-22.9-60.2 0-83.1 22.9-22.9 60.2-22.9 83.1 0l164.1 164.1c22.9 23 22.9 60.2 0 83.1z"
              fill="#6589f8"
              p-id="3531"
            ></path>
          </svg>
        </div>
        <div class="flex1"></div>
        <div>
          <el-button @click="jumpOver" class="width-full" type="primary">
            <span>先跳过，以后再认证</span>
            <i class="el-icon-d-arrow-right m-l-10"></i>
          </el-button>
        </div>
      </div>
      <!--  创建新企业  -->
      <CreateCompanies
        v-if="isCompanyData"
        @toSelectIdentity="toSelectIdentity"
        @createCompaniesSuccessful="createCompaniesSuccessful"
        class="client-login-right"
      />
      <!--  审核中  -->
      <div v-if="isUnderReview" class="client-login-right flex-center">
        <svg
          t="1700186490801"
          class="icon"
          viewBox="0 0 1300 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2387"
          width="128"
          height="128"
        >
          <path
            d="M784.014714 99.204787l10.903312 18.428134-21.294732-2.559463-14.179425 16.124617-4.095141-21.089976-19.707865-8.497417 18.735269-10.442609 2.04757-21.345922 15.715103 14.58894 20.936408-4.658223-9.060499 19.451919zM1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931z"
            fill="#F59A23"
            p-id="2388"
          ></path>
          <path
            d="M1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931zM571.886418 100.023815l-17.404348-12.541369 20.526893-6.1939 6.501036-20.424515 12.234233 17.609105 21.448301-0.153567-12.950883 17.097213 6.756982 20.373325-20.270947-7.012928-17.250781 12.694936 0.409514-21.4483zM991.382408 784.373039l-21.192354 3.480869 10.135474-18.888837-9.828338-19.093594 21.089975 3.788005 15.100832-15.254399 2.917788 21.243543 19.144783 9.623581-19.298351 9.367634-3.224923 21.192354-14.844886-15.459156zM427.993407 156.792705l-20.78284-5.323683 16.892456-13.258019-1.330921-21.397111 17.762674 11.927098 19.963811-7.883146-5.886765 20.629272 13.667533 16.534131-21.397111 0.819028-11.517584 18.069809-7.371253-20.117379zM854.19519 896.42633l-20.731651-5.323683 16.841267-13.258019-1.330921-21.397111 17.813863 11.978287 19.912622-7.934335-5.835575 20.629272 13.667532 16.534131-21.4483 0.819028-11.517584 18.069809-7.371253-20.117379zM562.416405 923.607827l10.903313 18.428134-21.294733-2.559463-14.179425 16.073428-4.14633-21.038786-19.656676-8.497418 18.735269-10.442609 1.996381-21.345921 15.715103 14.588939 20.936408-4.658223-9.00931 19.451919zM242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499z"
            fill="#F59A23"
            p-id="2389"
          ></path>
          <path
            d="M242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499zM700.780976 943.878774l-17.404348-12.490179 20.475704-6.24509 6.552225-20.424515 12.234233 17.609106 21.448301-0.102379-12.950883 17.097213 6.756982 20.322136-20.270947-7.012928-17.30197 12.694936 0.460703-21.4483zM303.552315 278.827902l-21.192354 3.42968 10.135473-18.888837-9.828338-19.042405 21.089976 3.788006 15.100832-15.2544 2.917787 21.243543 19.144784 9.623581-19.298351 9.316445-3.224924 21.243544-14.844885-15.459157z"
            fill="#F59A23"
            p-id="2390"
          ></path>
          <path
            d="M407.620081 90.604991a486.861057 486.861057 0 0 1 504.521352 11.77353l25.031548-14.435371a511.892605 511.892605 0 0 0-797.528678 459.57718l25.031548-14.384182A486.758678 486.758678 0 0 1 407.620081 90.604991zM893.201406 933.333787a486.861057 486.861057 0 0 1-504.521351-11.619963l-24.980359 14.384183A511.892605 511.892605 0 0 0 1161.177185 476.572015L1136.401583 490.956197a486.912246 486.912246 0 0 1-243.200177 442.37759z"
            fill="#F59A23"
            p-id="2391"
          ></path>
          <path
            d="M813.909242 795.839433a326.587482 326.587482 0 0 1-258.147441 29.536203l-29.792149 17.199592a353.205897 353.205897 0 0 0 472.73282-272.429245l-29.792149 17.148403A326.843428 326.843428 0 0 1 813.909242 795.839433zM486.861057 228.099345a326.587482 326.587482 0 0 1 258.14744-29.536204l29.79215-17.199591A353.205897 353.205897 0 0 0 302.016637 453.792794l29.843339-17.148402a326.485103 326.485103 0 0 1 155.001081-208.545047zM1288.280119 374.705387a53.441588 53.441588 0 0 1-14.384182 11.978287l-1044.260914 601.934514a53.799913 53.799913 0 0 1-73.4054-19.759055L7.217686 710.660503a53.697534 53.697534 0 0 1 19.707865-73.405399L1071.442411 35.32059a53.799913 53.799913 0 0 1 73.4054 19.759054l148.80718 258.19863a53.953481 53.953481 0 0 1-5.374872 61.427113zM32.198045 665.716333a28.102904 28.102904 0 0 0-2.815409 32.146855l148.80718 258.19863a28.154093 28.154093 0 0 0 38.443134 10.237852L1261.149811 364.518724a28.154093 28.154093 0 0 0 10.237852-38.443135l-148.755991-258.249819a28.102904 28.102904 0 0 0-38.391945-10.237852L39.722866 659.420054a27.130308 27.130308 0 0 0-7.524821 6.296279z"
            fill="#F59A23"
            p-id="2392"
          ></path>
          <path
            d="M476.93034 500.938103l22.062571 38.289567-15.356778 8.804553-13.923479-24.058953-151.5714 87.584825 14.588939 25.133927-15.356778 8.855742-22.728032-39.364541L377.93031 557.962939c-6.091522-4.81179-11.415205-8.753364-15.868671-11.824719l14.947265-12.43899q5.989143 4.760601 17.097213 14.947264z m-17.046024 196.669139l-48.527419 28.000525 7.473632 12.899694-15.356778 8.804553-61.427112-105.961769 63.833007-36.856268-12.592558-21.857814L409.514084 573.319718l12.643747 21.857814L486.297975 557.962939l60.812841 105.347498-15.356778 8.855743-6.961739-11.82472-49.14169 28.358851 25.59463 44.381089-15.715103 9.060499zM414.63301 618.929349l-48.527419 28.000525 14.486561 25.133927 48.527419-28.000525zM388.526487 685.936091l14.53775 25.133927 48.527419-28.000526-14.53775-25.133927z m105.347498-79.496922l-14.48656-25.133927-49.397637 28.512418 14.742507 24.92917z m-26.567226 67.518635l49.192879-28.358851-14.53775-25.133927-49.14169 28.358851zM658.703404 641.094298l-15.356778 8.702175-63.218737-109.493828a300.839284 300.839284 0 0 1 7.524821 76.11843l-15.561535-12.387801a258.761712 258.761712 0 0 0-11.415205-96.542945l-29.536203 17.046023-8.702174-15.356778 30.201663-17.404348-24.622034-42.640654 15.049643-8.702175 24.622034 42.640654 25.59463-14.896075 8.702174 15.049643-25.59463 14.896075 8.241471 14.230614q24.673224 8.446228 55.489158 22.420896l-1.023785 18.376945q-28.717175-16.380563-44.637035-23.751817z m27.079119-17.660294l-16.380564-8.650985a225.232746 225.232746 0 0 0 59.379543-163.805634l17.404348-0.71665a249.752402 249.752402 0 0 1-7.6272 72.586372 377.008904 377.008904 0 0 1 64.191333 18.325755l-4.81179 17.916241a350.28811 350.28811 0 0 0-63.67944-20.936407 244.121583 244.121583 0 0 1-48.322662 85.281308z m-97.669109-176.756517l54.618941-31.532584a164.266337 164.266337 0 0 0-22.983978-15.356779l14.691318-11.927097a287.171751 287.171751 0 0 1 23.598249 18.68408L706.411795 378.288635l8.190281 14.179425-59.891434 34.60394c0.307136 28.41004-1.586867 49.602393-5.52844 63.525873 17.353159-11.568773 30.713556-20.475704 39.620487-26.669605a194.51919 194.51919 0 0 0 0.870218-33.426587L706.411795 429.989788q4.709412 84.359901-44.944171 144.251336l-16.124617-8.190281a182.233767 182.233767 0 0 0 40.951408-82.517088q-27.488633 17.916241-47.554823 30.713556l-10.698555-11.005691 1.586867-1.586867 0.921407-1.433299q8.139092-15.766292 8.395038-63.73063L596.303695 460.703344zM805.155878 288.144347l16.175807-9.367634 22.728031 39.364541 78.473137-45.302496 59.328353 102.736846-15.766293 9.060499-7.934335-13.769911-62.706844 36.241997 42.998979 74.531563-16.175807 9.316445-42.998979-74.531563-62.553276 36.088429 7.985525 13.769911-15.91986 9.111688-59.123596-102.736846 78.21719-45.046549z m2.76422 149.063127l62.502087-35.832482L836.739652 342.968045l-62.502087 35.832483z m78.677894-45.404874l62.706844-36.241997-33.682534-58.355757-62.706844 36.241997z"
            fill="#F59A23"
            p-id="2393"
          ></path>
        </svg>
        <div class="font-size-20 m-t-50">
          您好，您的注册申请还在审核中
        </div>
        <div class="font-size-16 m-t-10 m-b-50">
          暂时无法登录系统！
        </div>
        <el-button @click="goBackLogin" class="width-full m-t-50" type="primary">返回登录</el-button>
        <StoreCom />
      </div>
      <!--  同时在线用户数超限  -->
      <div v-if="isTransfinite" class="client-login-right flex-center">
        <i class="el-icon-warning text-warning" style="font-size: 60px"></i>
        <div class="font-size-16 m-t-30">
          同时在线用户数超限
        </div>
        <div class="font-size-16 m-t-10">
          请联系商城客服进行处理
        </div>
        <div class="font-size-16 m-t-10 m-b-50 text-primary">客服热线：{{ companyInfo.servicePhone }}</div>
        <el-button @click="goBackLogin" class="width-full m-t-50" type="primary">返回登录</el-button>
        <StoreCom />
      </div>
      <!--  商城停用  -->
      <div v-if="isMallStop" class="client-login-right flex-center">
        <i class="el-icon-warning text-warning" style="font-size: 60px"></i>
        <div class="font-size-16 m-t-30">
          商城已停用
        </div>
        <div class="font-size-16 m-t-10">
          请联系商城客服进行处理
        </div>
        <div class="font-size-16 m-t-10 m-b-50 text-primary">客服热线：{{ companyInfo.servicePhone }}</div>
        <el-button @click="goBackLogin" class="width-full m-t-50" type="primary">返回登录</el-button>
        <StoreCom />
      </div>
    </div>
    <CopyrightCom />
    <MobileEnter />
  </div>
</template>

<script>
import PassWord from "@/components/PassWord";
import SMSCode from "@/components/SMSCode";
import SelectArea from "@/components/selectArea/SelectArea.vue";
import StoreCom from "@/components/StoreCom";
import CopyrightCom from "@/components/CopyrightCom";
import MobileEnter from "@/components/MobileEnter";
import CreateCompanies from "@/components/CreateCompanies";
import {
  passwordValidate,
  passwordValidateTwo,
  passwordValidateTips,
  passwordValidateTipsTwo,
  phoneValidate,
  phoneValidateTips
} from "@/utils/validate";
import { loadAccountList } from "@/common/baseData";
import { passwordLogin, SmsLogin, register, customerApplication } from "@/api/base";
import bus from "@/utils/bus";
import { setIsLogin } from "@/utils/loginStorage";

const defaultLoginData = {
  phone: "",
  account: "",
  password: "",
  smsCaptcha: ""
};

const defaultRegisterData = {
  name: "",
  phone: "",
  account: "",
  cooperatorId: 0,
  password: "",
  smsCaptcha: "",
  type: 1,
  device: "",
  areaId: 0,
  system: "",

  read: false
};

export default {
  name: "ClientLogin",
  mixins: [],
  components: {
    PassWord,
    SMSCode,
    SelectArea,
    StoreCom,
    CopyrightCom,
    MobileEnter,
    CreateCompanies
  },
  data() {
    return {
      desc: "登录",
      query: {},
      activeName: "one",
      loading: false,
      readonly: true,
      // 微信登录
      isWeiXinLogin: false,
      // 注册
      isRegister: false,
      // 选择省份
      isSelectIdentity: false,
      // 企业资料
      isCompanyData: false,
      // 审核中
      isUnderReview: false,
      // 同时在线用户数超限
      isTransfinite: false,
      // 商城停用
      isMallStop: false,
      // 登录
      loginData: JSON.parse(JSON.stringify(defaultLoginData)),
      // 注册
      registerData: JSON.parse(JSON.stringify(defaultRegisterData)),
      // 账号列表
      accountList: [],
      // 微信登录
      iframeUrl:
        "https://open.weixin.qq.com/connect/qrconnect?appid=wxf5a4ad338dd1a80d&redirect_uri=https%3A%2F%2Ferp.threesoft.cn%2Fapi%2Fuser-binds%2Fcallback%3Fdevice%3D73651971addefa586fa671617ca1f213%26printerDevice%3D479D3C6A-5FCF-9ADC-56D2-CB3F84EABFBE%26redirect%3Dhttps%253A%252F%252Ferp.threesoft.cn%252FWeiXinLogin&response_type=code&scope=snsapi_login&state=SR6658308b9cad4a4a400a76c26edb9ff5&href=https://erp.threesoft.cn/login/weixinlogin.css"
    };
  },
  watch: {
    "loginData.phone"() {
      if (this.isLoginShow) {
        this.getAccountList();
      }
    },
    activeName() {
      this.accountList = [];
      this.loginData = JSON.parse(JSON.stringify(defaultLoginData));
      this.registerData = JSON.parse(JSON.stringify(defaultRegisterData));
    }
  },
  computed: {
    isLoginShow() {
      return (
        !this.isWeiXinLogin &&
        !this.isRegister &&
        !this.isSelectIdentity &&
        !this.isCompanyData &&
        !this.isUnderReview &&
        !this.isTransfinite &&
        !this.isMallStop
      );
    },
    companyInfo() {
      return this.$store.state.companyInfo.company;
    },
    emblem() {
      return this.$store.state.companyInfo.emblem;
    },
    storeName() {
      return this.$store.state.companyInfo.storeName;
    },
    showRegister() {
      return this.$store.state.companyInfo.company.setting.allowExternalRegistration;
    }
  },
  created() {
    setIsLogin(false);
  },
  mounted() {
    this.query = this.$route.query;
    if (this.query.type === "beyond-max-login") {
      this.loginState("transfinite");
    }
    if (this.query.method === "register") {
      this.toRegister();
    }
    bus.$on("beyond-max-login", state => {
      if (state) {
        this.loading = false;
        this.loginState("transfinite");
      }
    });
  },
  methods: {
    // 去注册
    toRegister() {
      this.isRegister = true;
      setTimeout(() => {
        this.readonly = false;
      }, 500);
    },
    // 去登录
    toLogin() {
      this.isRegister = false;
      this.readonly = true;
    },
    // 去选择身份
    toSelectIdentity() {
      this.isSelectIdentity = true;
      this.isCompanyData = false;
    },
    // 返回登录
    goBackLogin() {
      this.isUnderReview = false;
      this.isTransfinite = false;
      this.isMallStop = false;
    },
    // 忘记密码
    forgetPassword() {
      this.$router.push({
        path: "/forget-password"
      });
    },
    // 去微信登录
    weiXinLogin() {
      this.changeWeiXinLogin();
    },
    changeWeiXinLogin() {
      this.isWeiXinLogin = !this.isWeiXinLogin;
    },
    // 用户服务协议
    serviceAgreement() {
      window.open(this.$store.state.user_service_agreement, "_black");
    },
    // 隐私政策
    privacyPolicy() {
      window.open(this.$store.state.privacy_policy, "_black");
    },
    // 登录
    login() {
      if (this.activeName === "one") {
        if (!this.loginData.phone) {
          this.$message.error("请输入用户名/手机号！");
          return;
        }
        if (this.accountList.length > 1 && !this.loginData.account) {
          this.$message.error("请选择账号！");
          return;
        }
        if (!this.loginData.password) {
          this.$message.error("请输入密码！");
          return;
        }
        if (!passwordValidateTwo(this.loginData.password)) {
          this.$message.error(passwordValidateTipsTwo);
          return;
        }
        // 账号密码登录
        const data = {
          phone: this.loginData.account || this.loginData.phone, // 手机号或账号
          password: this.loginData.password, // 密码
          type: "1", // 设备平台类型
          device: window.deviceKey, // 设备号
          system: "" // 系统
        };
        this.loading = true;
        passwordLogin(data)
          .then(res => {
            this.loading = false;
            if (res) {
              // 商家端登录
              window.location.href = `${window.location.origin}/seller`;
            } else {
              this.loginState("ok");
            }
          })
          .catch(err => {
            this.loading = false;
            this.$message.error(err.message || "登录失败！");
          });
      } else {
        if (!this.loginData.phone) {
          this.$message.error("请输入手机号！");
          return;
        }
        if (!phoneValidate(this.loginData.phone)) {
          this.$message.error(phoneValidateTips);
          return;
        }
        if (this.accountList.length > 1 && !this.loginData.account) {
          this.$message.error("请选择账号！");
          return;
        }
        if (!this.loginData.smsCaptcha) {
          this.$message.error("请输入验证码！");
          return;
        }
        if (this.loginData.smsCaptcha.length !== 6) {
          this.$message.error("验证码位数不正确！");
          return;
        }
        // 短信验证码登录
        const data = {
          phone: this.loginData.phone, // 手机号
          account: this.loginData.account, // 账号
          smsCaptcha: this.loginData.smsCaptcha, // 短信验证码
          type: "1", // 设备平台类型
          device: window.deviceKey, // 设备号
          system: "" // 系统
        };
        this.loading = true;
        SmsLogin(data)
          .then(() => {
            this.loading = false;
            this.loginState("ok");
          })
          .catch(err => {
            this.loading = false;
            this.$message.error(err.message || "登录失败！");
          });
      }
    },
    // 注册
    register() {
      if (!this.registerData.name) {
        this.$message.error("请输入请输入姓名！");
        return;
      }
      if (!this.registerData.phone) {
        this.$message.error("请输入手机号！");
        return;
      }
      if (!phoneValidate(this.registerData.phone)) {
        this.$message.error(phoneValidateTips);
        return;
      }
      if (!this.registerData.smsCaptcha) {
        this.$message.error("请输入手机验证码！");
        return;
      }
      if (!this.registerData.password) {
        this.$message.error("请输入登录密码！");
        return;
      }
      if (!passwordValidate(this.registerData.password)) {
        this.$message.error(passwordValidateTips);
        return;
      }
      if (!this.registerData.areaId) {
        this.$message.error("请选择所在地区！");
        return;
      }
      if (!this.registerData.read) {
        this.$message.error("请勾选阅读并同意！");
        return;
      }
      this.loading = true;
      const registerData = JSON.parse(JSON.stringify(this.registerData));
      registerData.device = window.deviceKey;
      register(registerData)
        .then(() => {
          this.loading = false;
          this.isRegister = false;
          this.isSelectIdentity = true;
        })
        .catch(err => {
          this.loading = false;
          if (err.code === "phone_errors") {
            this.$confirm("当前手机号已在该商城注册了账号，无法重复注册！", "提示", {
              confirmButtonText: "返回登录",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.toLogin();
            });
          } else {
            this.$message.error(err.message || "注册失败！");
          }
        });
    },
    // 登录状态
    loginState(type) {
      // 手机号未注册
      if (type === "unregistered") {
        this.$confirm("当前手机号还未注册！请先注册账号", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {});
        return;
      }
      // 账号审核中
      if (type === "underReview") {
        this.isUnderReview = true;
        return;
      }
      // 登录在线用户超出限制
      if (type === "transfinite") {
        this.isTransfinite = true;
        return;
      }
      // 商城停用
      if (type === "mallStop") {
        this.isMallStop = true;
        return;
      }
      // 正常登录
      if (type === "ok") {
        setIsLogin(true);
        window.location.replace("/");
      }
    },
    // 获取账号列表
    async getAccountList() {
      this.accountList = await loadAccountList(this.loginData.phone);
      if (this.accountList.length === 1) {
        this.loginData.account = this.accountList[0];
      } else {
        this.loginData.account = "";
      }
    },
    areaChange(area) {
      if (area && area.areaIds.length) {
        this.registerData.areaId = area.areaIds[area.areaIds.length - 1];
      } else {
        this.registerData.areaId = "";
      }
    },
    // 创建新企业
    createEnterprise() {
      this.isCompanyData = true;
    },
    // 加入已有企业
    addEnterprise() {
      console.log("===", "name");
    },
    // 先跳过，以后再认证
    jumpOver() {
      customerApplication()
        .then(() => {
          this.$message.success("注册成功！");
          setTimeout(() => {
            this.loginState("ok");
          }, 500);
        })
        .catch(err => {
          this.$message.error(err.message || "注册失败！");
        });
    },
    createCompaniesSuccessful() {
      customerApplication()
        .then(() => {
          setTimeout(() => {
            this.loginState("ok");
          }, 500);
        })
        .catch(err => {
          this.$message.error(err.message || "提交申请失败！");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.client-login-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f5f6ff;
  .client-login-title {
    padding: 24px 0;
    .client-login-title-img {
      width: 44px;
      height: 44px;
      border-radius: 100%;
      box-shadow: 0 0 5px rgba(153, 153, 153, 0.5);
    }
  }
  .client-login {
    margin: auto;
    width: 1050px;
    height: 560px;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 20px #e6e7ea;
    .client-login-right {
      width: 50%;
      height: 100%;
      padding: 20px 40px;
      display: flex;
      overflow: auto;
      flex-direction: column;
      box-sizing: border-box;
      background-color: #ffffff;
      transform: scale(1);
      ::v-deep  .el-tabs {
        .el-tabs__nav {
          width: 100%;
          display: flex;
          .el-tabs__item {
            flex: 1;
            font-size: 16px;
            text-align: center;
          }
        }
      }
      #iframeWeChat {
        margin-top: 20px;
        width: 100%;
        height: 320px;
        border: 0;
      }
      .select-identity-item {
        cursor: pointer;
        padding: 20px;
        border-radius: 10px;
        border: 1px solid #6589f8;
      }
    }
  }
}
</style>
